import React, { useEffect, useState } from 'react';
import CtaLink from '../Global/CtaLink';
//@ts-ignore
import * as styles from './ImageCopyBlock.module.css';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { graphql } from 'gatsby';
import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentMedia,
    BrandColor,
    CTALocation,
    KontentNumberValue,
} from '../../../types/KontentProps';
import { getColor, getMediaData } from '../Global/DataUtils';
import RichText from '../Global/RichText';
import { getImageData } from '../Global/DataUtils/gatsbyImageUtils';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { getDevicePlatform } from '../../global/utility';
import {
    optimizeKontentImageUrl,
    buildKontentSrcSet,
} from '../Global/DataUtils';

type WindowAction = 'New Window' | 'Same Window';

interface Props extends KontentNumberValue {
    kontentItemId?: string;
    component_anchor_name: KontentStringValue;
    number_of_items_in_row?: KontentNumberValue;
    content_alignment?: {
        value: [
            {
                codename: string;
            }
        ];
    };
    panels: {
        value: [
            {
                elements: {
                    content_panel__content_panel_color: BrandColor;
                    content_panel__content_panel_font_color: BrandColor;
                    banner_copy?: KontentStringValue;
                    banner_font_color?: BrandColor;
                    banner_background_color?: BrandColor;
                    description: KontentStringValue;
                    headline: KontentStringValue;
                    subheadline: KontentStringValue;
                    cta_configuration__cta_label: KontentStringValue;
                    cta_configuration__cta_location: CTALocation;
                    cta_configuration__cta_location_anchor_point: KontentStringValue;
                    cta_configuration__cta_window_action: KontentRadioMultiChoice<WindowAction>;
                    untitled_linked_items: KontentMedia;
                    hide_cta: {
                        value: [
                            {
                                codename: string;
                            }
                        ];
                    };
                };
            }
        ];
    };
}

const ImageCopyBlock: React.FC<Props> = ({
    panels,
    component_anchor_name,
    number_of_items_in_row,
    content_alignment,
    kontentItemId,
}) => {
    const breakpoints = useBreakpoint();
    const [isIOSorMacOS, setIsIOSorMacOS] = useState(false);

    const checkOS = () => {
        setIsIOSorMacOS(
            typeof window !== 'undefined' &&
                (!!navigator.userAgent.match(/Mac/i) ||
                    !!getDevicePlatform.iOS())
        );
    };

    useEffect(() => {
        checkOS();
    }, []);
    const contentCenterAlignment =
        content_alignment?.value[0]?.codename === 'center';
    const NoOfCardsPerRow = number_of_items_in_row?.value
        ? Math.min(number_of_items_in_row?.value, 4)
        : panels?.value?.length > 4
        ? 4
        : panels?.value?.length;

    const backgroundColor = getColor(
        panels.value[0]?.elements?.content_panel__content_panel_color
    );
    const textColor = getColor(
        panels.value[0]?.elements?.content_panel__content_panel_font_color
    );
    const bannerFontColor =
        getColor(panels.value?.[0]?.elements?.banner_font_color) || undefined;
    const bannerBackColor =
        getColor(panels.value?.[0]?.elements?.banner_background_color) ||
        undefined;

    const isbackgroundColor = backgroundColor ? backgroundColor : undefined;
    const istextColor = textColor ? textColor : undefined;
    const hideCta = panels.value[0]?.elements?.hide_cta?.value[0]?.codename;
    const colorStyles = {
        backgroundColor: isbackgroundColor,
        color: istextColor,
    };

    const contentWidthStyles =
        breakpoints.md && !breakpoints.xl
            ? {
                  flex: `1 1 50%`,
                  margin: '1rem',
                  maxWidth: 'calc(50% - 2rem)',
              }
            : breakpoints.xl
            ? {
                  flex: `1 1 ${
                      NoOfCardsPerRow == 4
                          ? '25%'
                          : NoOfCardsPerRow == 3
                          ? '33%'
                          : '50%'
                  }`,
                  margin: NoOfCardsPerRow ? '1rem' : '',
                  maxWidth:
                      NoOfCardsPerRow === 2
                          ? '610px'
                          : `calc(${
                                NoOfCardsPerRow === 4
                                    ? '25%'
                                    : NoOfCardsPerRow === 3
                                    ? '33%'
                                    : '50%'
                            } - 2rem)`,
              }
            : {};

    const bannerStyles = {
        background: bannerBackColor,
        color: bannerFontColor,
        padding: isIOSorMacOS ? '5px 1rem 8px 1rem' : '8px 1rem 5px 1rem',
        fontSize:
            breakpoints.xl && NoOfCardsPerRow === 3
                ? '1.4rem'
                : breakpoints.xl && NoOfCardsPerRow === 4
                ? '1rem'
                : !breakpoints.sm
                ? '0.75rem'
                : breakpoints.md && !breakpoints.l
                ? '1rem'
                : breakpoints.l && !breakpoints.xl
                ? '1.3rem'
                : '1.5rem',
        left: breakpoints.xl
            ? '62%'
            : !breakpoints.md || (breakpoints.md && !breakpoints.l)
            ? '60%'
            : '65%',
    };

    return (
        <div
            className={styles.main}
            id={component_anchor_name?.value}
            data-kontent-item-id={kontentItemId}
            style={{
                textAlign: contentCenterAlignment ? 'center' : 'left',
            }}
        >
            {panels &&
                panels.value.map((tag: any, index) => {
                    const image =
                        tag.elements?.untitled_linked_items &&
                        getImageData(tag.elements.untitled_linked_items);
                    const bannerCopy = tag.elements.banner_copy.value;

                    return (
                        <div
                            className={styles.content}
                            key={index}
                            style={{ ...colorStyles, ...contentWidthStyles }}
                        >
                            <div
                                className={styles.halfheaderimage}
                                style={
                                    bannerCopy ? { position: 'relative' } : {}
                                }
                            >
                                {bannerCopy && (
                                    <p
                                        className={`${styles.banner} ${
                                            NoOfCardsPerRow === 4
                                                ? styles.LargeScreenBanner
                                                : ''
                                        } ${
                                            !breakpoints.sm
                                                ? styles.smalllScreenBanner
                                                : ''
                                        }`}
                                        style={bannerStyles}
                                        data-kontent-element-codename="banner_copy"
                                    >
                                        {bannerCopy}
                                    </p>
                                )}
                                {hideCta?.toLowerCase() !== 'yes' ? (
                                    <div
                                        className={styles.imageCta}
                                        data-kontent-element-codename="untitled_linked_items"
                                    >
                                        <CtaLink
                                            href={
                                                tag.elements
                                                    .cta_configuration__cta_location_anchor_point
                                                    ?.value
                                                    ? BuildLinkHref(
                                                          tag.elements
                                                              .cta_configuration__cta_location
                                                      ) +
                                                      '#' +
                                                      tag.elements
                                                          .cta_configuration__cta_location_anchor_point
                                                          ?.value
                                                    : BuildLinkHref(
                                                          tag.elements
                                                              .cta_configuration__cta_location
                                                      )
                                            }
                                            target={
                                                tag.elements.ctaWindowAction ===
                                                'new_window'
                                                    ? '_blank'
                                                    : undefined
                                            }
                                            color={istextColor}
                                        >
                                            {image?.image && (
                                                <img
                                                    src={
                                                        image.image
                                                            ? optimizeKontentImageUrl(
                                                                  (image.image
                                                                      ?.url ||
                                                                      image.image) as string,
                                                                  {
                                                                      w: 800,
                                                                      fit: 'crop',
                                                                      q: 80,
                                                                      auto: 'format',
                                                                  }
                                                              )
                                                            : ''
                                                    }
                                                    srcSet={
                                                        image.image
                                                            ? buildKontentSrcSet(
                                                                  (image.image
                                                                      ?.url ||
                                                                      image.image) as string,
                                                                  800,
                                                                  {
                                                                      fit: 'crop',
                                                                      q: 80,
                                                                      auto: 'format',
                                                                  }
                                                              )
                                                            : ''
                                                    }
                                                    sizes="(max-width: 800px) 100vw, 800px"
                                                    alt={image.alt}
                                                    width={800}
                                                    height={undefined}
                                                    loading="lazy"
                                                    style={{
                                                        width: '100%',
                                                        height: 'auto',
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                            )}
                                        </CtaLink>
                                    </div>
                                ) : image?.image ? (
                                    <div data-kontent-element-codename="untitled_linked_items">
                                        <img
                                            src={
                                                image.image
                                                    ? optimizeKontentImageUrl(
                                                          (image.image?.url ||
                                                              image.image) as string,
                                                          {
                                                              w: 800,
                                                              fit: 'crop',
                                                              q: 80,
                                                              auto: 'format',
                                                          }
                                                      )
                                                    : ''
                                            }
                                            srcSet={
                                                image.image
                                                    ? buildKontentSrcSet(
                                                          (image.image?.url ||
                                                              image.image) as string,
                                                          800,
                                                          {
                                                              fit: 'crop',
                                                              q: 80,
                                                              auto: 'format',
                                                          }
                                                      )
                                                    : ''
                                            }
                                            sizes="(max-width: 800px) 100vw, 800px"
                                            alt={image.alt}
                                            width={800}
                                            height={undefined}
                                            loading="lazy"
                                            className={styles.image}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            <div className={styles.textContent}>
                                <div className={styles.heading}>
                                    <h3 data-kontent-element-codename="headline">
                                        {tag.elements.headline.value}
                                    </h3>
                                </div>
                                {tag.elements?.subheadline?.value && (
                                    <div
                                        className={styles.subheadline}
                                        data-kontent-element-codename="subheadline"
                                    >
                                        {tag.elements?.subheadline?.value}
                                    </div>
                                )}
                                <div className={styles.para}>
                                    {RichText(
                                        tag.elements.description,
                                        false,
                                        undefined,
                                        undefined,
                                        'description'
                                    )}
                                </div>
                                {hideCta?.toLowerCase() !== 'yes' && (
                                    <div className={styles.cta}>
                                        <CtaLink
                                            href={
                                                tag.elements
                                                    .cta_configuration__cta_location_anchor_point
                                                    ?.value
                                                    ? BuildLinkHref(
                                                          tag.elements
                                                              .cta_configuration__cta_location
                                                      ) +
                                                      '#' +
                                                      tag.elements
                                                          .cta_configuration__cta_location_anchor_point
                                                          ?.value
                                                    : BuildLinkHref(
                                                          tag.elements
                                                              .cta_configuration__cta_location
                                                      )
                                            }
                                            target={
                                                tag.elements.ctaWindowAction ===
                                                'new_window'
                                                    ? '_blank'
                                                    : undefined
                                            }
                                            color={istextColor}
                                        >
                                            {
                                                tag.elements
                                                    .cta_configuration__cta_label
                                                    ?.value
                                            }
                                        </CtaLink>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default ImageCopyBlock;

export const fragmentImageCopyBlock = graphql`
    fragment ImageCopyBlock on kontent_item_component___half_image_copy_block_a9f8fc6 {
        elements {
            component_anchor_name {
                value
            }
            number_of_items_in_row {
                value
            }
            content_alignment {
                value {
                    codename
                }
            }
            panels {
                value {
                    ... on kontent_item_content_item___general_structured_panel__copy_ {
                        id
                        elements {
                            headline {
                                value
                            }
                            subheadline {
                                value
                            }
                            hide_cta {
                                value {
                                    codename
                                }
                            }
                            content_panel__content_panel_color {
                                value {
                                    ... on kontent_item_list___brand_colors {
                                        id
                                        elements {
                                            color_hex_value {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            content_panel__content_panel_font_color {
                                value {
                                    ... on kontent_item_list___brand_colors {
                                        id
                                        elements {
                                            color_hex_value {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            cta_configuration__cta_label {
                                value
                            }
                            cta_configuration__cta_location {
                                ...kontentCtaLocation
                            }
                            cta_configuration__cta_location_anchor_point {
                                value
                            }
                            cta_configuration__cta_window_action {
                                value {
                                    codename
                                }
                            }
                            description {
                                links {
                                    codename
                                }
                                images {
                                    url
                                }
                                value
                            }
                            untitled_linked_items {
                                ...kontentImage
                            }
                            banner_copy {
                                value
                            }
                            banner_background_color {
                                ...kontentColor
                            }
                            banner_font_color {
                                ...kontentColor
                            }
                        }
                    }
                }
            }
        }
    }
`;
